<template>
   <div class="loader"></div>
</template>

<script>
    export default {
        name:'Loader'
    }
</script>

<style lang="scss" scoped>
.loader {
  border: 2px solid white; /* Light grey */
  border-top: 2px solid red; /* Blue */
  border-radius: 50%;
  width: 15px;
  height: 15px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>